// extracted by mini-css-extract-plugin
export default {"outerDiv":"HeroComponent_outerDiv__SxMhr","innerDiv":"HeroComponent_innerDiv__7pRZH","scr1":"HeroComponent_scr1__LKb5x","scr2":"HeroComponent_scr2__E6ERz"};